/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_UnarchiveInputs */

const en_action_unarchive = /** @type {(inputs: Action_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore`)
};

/**
* | output |
* | --- |
* | "Restore" |
*
* @param {Action_UnarchiveInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const action_unarchive = /** @type {((inputs?: Action_UnarchiveInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_UnarchiveInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_action_unarchive(inputs)
});